import {COMMISSION_GROUP_USER_GROUP} from "localConstants.ts";

export const isUUID = (segment: string) =>
    /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(segment);

export const isDynamicParam = (segment: string) => isUUID(segment) || customDynamicParams.includes(segment);

const customDynamicParams = [COMMISSION_GROUP_USER_GROUP];
